<template>
  <div id="reportTable">
    <div class="title">
      <h3 style="display: none;">{{ data.full_name }} {{ title }}</h3>
    </div>

    <!-- Reports Table -->
    <table>
      <thead v-bind:style="{ 'background-color':  reportColour}">
        <tr>
          <template>
            <th>
              Pos
            </th>
            <th v-if="home === false" class="hideMob">
              Country
            </th>
            <th>
              Player Name
            </th>
            <th v-if="data.show_winnings == 'B'" class="hideMob theadSpaceValue">
              <span v-if="data.show_winnings == 'Y' || Eds[0].winnings">Winnings</span>
              <span v-else-if="data.show_winnings == 'P'">
                <span v-if="data.show_points_name != ''">{{ data.show_points_name }}</span>
                <span v-else>Points</span>
              </span>
              <!-- <span v-else >Winnings</span> -->
            </th>
            <th v-else-if="data.show_winnings == 'P'" class="hideMob theadSpaceValue">Points</th>
            <!-- <th v-else-if="data.show_winnings == 'P' && data.result.result_entry[0].points || data.result.result_entry[0].winnings" class="hideMob theadSpaceValue">Points</th> -->
            <th v-else class="hideMob theadSpaceValue"><span v-if="data.result.result_entry[0].winnings" >Winnings</span></th>
            <th class="hideMob" v-if="data.show_winnings == 'B' && data.have_points == 'Y'">
              {{ data.show_points_name }}
            </th>
            <template v-if="match === 'N'">
              <th class="theadSpace">
                Par
              </th>
              <th class="theadSpace">
                Score 
              </th>
              <th v-for="(i, roundIt) in range(1, roundsPlayed)" :key="roundIt" class="hideMob theadSpace">
                  <span
                    v-if="data.playoff == 'Y' && i == data.playoff_round_num
                    "
                    class="playOFFred"
                    >Playoff</span
                  >
                  <!-- <span v-else>R{{ i }}</span> -->
                  <span v-else-if="data.rounds_played  > 1 ">R{{ i }}</span>
                  <span else ></span>
              </th>
              <th v-if="config.VUE_APP_PLAYER_ICON === 'Y'" class="hideMob"></th>
            </template>
          </template>
        </tr>
      </thead>
      <tbody>

      <template>
        <template v-for="(tabledata, index) in Eds.slice(0,5)">
          <tr @click.stop="rowClicked(index)" :key="index">
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.cut_round }}
              </td>
              <td class="cut" colspan="11" v-else-if="tabledata.pos === 'EOQ'">
                {{ tabledata.pos }}
              </td>
              <td
                class="posnum scorePos"
                v-else-if="index !== 0"
              >
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum scorePos" v-else-if="index === 0" >
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>


              <td v-else class="noPos"><span>.</span></td>

              <td class="mobHide" v-if="tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ' &&  home === false">
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <img
                    class="flag"
                    :src="
                      (config.VUE_APP_FLAG_URL + tabledata.nationality)
                        | lowercase
                    "
                  />
                  {{ tabledata.represents }}
                </span>
              </td>
              <td
                v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                }"
              >
              <template v-if="tabledata.profile == 'N'">
                  {{ tabledata.playing_name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="oomTitleiest" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y' && home === false"
                    ><b-img
                      class="openImage"
                      src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/11/theopen.png"
                    ></b-img
                  ></span>
                  <template v-if="showGender == 'Y' && tourID !== 'wpg' && tabledata.gender == 'F'">
                    <!-- <span class="genderBall" :class="{male : tabledata.gender == 'M'}">•</span> -->
                    <span class="genderBall" :class="{female : tabledata.gender == 'F'}"></span>
                  </template>
                  <template v-else-if="showGender == 'Y' && tourID == 'wpg' && tabledata.gender == 'M'">
                    <span class="genderBall" :class="{male : tabledata.gender == 'M'}"></span>
                  </template>
              </template>
              <template v-else>
                <b-link  class="nameLink" @click="newtab(tabledata.member_no)" v-model="playernum">
                  {{ tabledata.playing_name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="oomTitleiest" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y' && home === false"
                    ><b-img
                      class="openImage"
                      src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/11/theopen.png"
                    ></b-img
                  ></span>
                  <template v-if="showGender == 'Y' && tourID !== 'wpg' && tabledata.gender == 'F'">
                    <!-- <span class="genderBall" :class="{male : tabledata.gender == 'M'}">•</span> -->
                    <span class="genderBall" :class="{female : tabledata.gender == 'F'}"></span>
                  </template>
                  <template v-else-if="showGender == 'Y' && tourID == 'wpg' && tabledata.gender == 'M'">
                    <span class="genderBall" :class="{male : tabledata.gender == 'M'}"></span>
                  </template>
                </b-link>
              </template>
              </td>
              <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.pos !== 'EOQ'" class="hideMob">
                <span v-if="data.show_winnings != 'B'" class="winningsPos">
                  {{ tabledata.winnings }}
                </span>
                <span v-else-if="tabledata.winnings !== '' && tabledata.winnings">
                  {{data.currency_sign}}
                  {{ tabledata.winnings }}
                </span>
              </td>
              <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && data.show_winnings == 'B' && data.have_points == 'Y'" >
                {{tabledata.points_both}}
              </td>
              <template v-if="match === 'N'">
                <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar < 0" class="up posDown">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar > 0" class="down posDown">
                  {{ tabledata.vspar }}
                </td>
                <td  class="posDown" v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ'">
                  {{ tabledata.vspar }}
                </td>
                <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar < 0 && roundsPlayed > 1" class=" posDown">
                  {{ tabledata.score }}
                </td>
                <td
                  v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar > 0 && roundsPlayed > 1"
                  class=" posDown"
                >
                  {{ tabledata.score }}
                </td>
                <td class="posDown" v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && roundsPlayed > 1">
                  {{ tabledata.score }}
                </td>
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="hideMob"
                  v-show="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ'"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up posDown "
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down posDown"
                    >{{ tabledata.score }}</span
                  >
                  <span v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span v-else-if="tabledata['score_R' + i] < data.course_total_par.slice(1)" :class="up" class="posDown">{{
                    tabledata["score_R" + i]
                  }}</span>
                  <span
                    v-else-if="tabledata['score_R' + i] > data.course_total_par.slice(1)"
                    :class="down"
                    class="posDown"
                    >{{ tabledata["score_R" + i] }} </span
                  >
                  <span class="posDown" v-else>{{ tabledata["score_R" + i] }}</span>
                </td>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    tabledata.pos !== 'EOQ' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
                class="hideMob"
              >
                <a :href="'/playerprofile/' + tabledata.playerno">
                  <font-awesome-icon
                    style="color:#f2af15!important;"
                    id="user"
                    class="icon"
                    :icon="['fa', 'user']"
                  />
                </a>
              </td>
          </tr>
        </template>
        <tr class="middle-sec">
          <td colspan="11" style="text-align: center;">
            <template v-if="isMobile(true)">
              <div class="ad test"> 
                <div class="ad" style="text-align:center;">
                  <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" type="application/javascript"></script>
                  <script type="application/javascript">
                    window.googletag = window.googletag || {cmd: []};
                    googletag.cmd.push(function() {
                    billboardsizes = googletag.sizeMapping()
                    .addSize([0, 0], [320, 50])
                    .build();
                    googletag.defineSlot('/27436116/Golf_PGA_Leaderboard_Tournament_Pos5', [[320,50]], 'leaderboardpos5').defineSizeMapping(billboardsizes).addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    });
                  </script>

                  <div id='leaderboardpos5' class="lazy" style="text-align:center; margin:auto">
                    <div>
                      <script type="application/javascript">
                        googletag.cmd.push(function() { googletag.display('leaderboardpos5'); });
                      </script>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- Desktop Add -->
              <div class="ad test">
                <div class="ad" style="text-align:center;">
                  <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" type="application/javascript"></script>
                  <script type="application/javascript">
                    window.googletag = window.googletag || {cmd: []};
                    googletag.cmd.push(function() {
                    billboardsizes = googletag.sizeMapping()
                    .addSize([980, 0], [[970, 90],[728, 90]])
                    .build();
                    googletag.defineSlot('/27436116/Golf_PGA_Leaderboard_Tournament_Pos5', [[728,90],[970,90]], 'leaderboardpos5').defineSizeMapping(billboardsizes).addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    });
                  </script>

                  <div id='leaderboardpos5' class="lazy" style="text-align:center; margin:auto">
                    <div v-bind:style="{ 'background-image': 'url(' + 'https://tpc.googlesyndication.com/simgad/10671038089449318886' + ')' }" style="text-align:center; margin:auto; background-repeat: no-repeat; height: 90px; margin: auto; background-position: center;">
                      <script type="application/javascript">
                        googletag.cmd.push(function() { googletag.display('leaderboardpos5'); });
                      </script>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </td>
        </tr>
        <template v-for="(tabledata, index) in Eds.slice(5,25)">
          <tr @click.stop="rowClicked(index)" :key="index">
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.cut_round }}
              </td>
              <td class="cut" colspan="11" v-else-if="tabledata.pos === 'EOQ'">
                {{ tabledata.pos }}
              </td>
              <td
                class="posnum scorePos"
                v-else-if="index !== 0"
              >
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum scorePos" v-else-if="index === 0" >
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>


              <td v-else class="noPos"><span>.</span></td>

              <td class="mobHide" v-if="tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ' &&  home === false">
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <img
                    class="flag"
                    :src="
                      (config.VUE_APP_FLAG_URL + tabledata.nationality)
                        | lowercase
                    "
                  />
                  {{ tabledata.represents }}
                </span>
              </td>
              <td
                v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                }"
              >
              <template v-if="tabledata.profile == 'N'">
                {{ tabledata.playing_name }}
                <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                <span v-if="tabledata.sponsored === 'Y'"
                  ><b-img class="oomTitleiest" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                ></span>
                <span v-if="tabledata.entry_sponsored === 'Y' && home === false"
                  ><b-img
                    class="openImage"
                    src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/11/theopen.png"
                  ></b-img
                ></span>
                <template v-if="showGender == 'Y' && tourID !== 'wpg' && tabledata.gender == 'F'">
                  <!-- <span class="genderBall" :class="{male : tabledata.gender == 'M'}">•</span> -->
                  <span class="genderBall" :class="{female : tabledata.gender == 'F'}"></span>
                </template>
                <template v-else-if="showGender == 'Y' && tourID == 'wpg' && tabledata.gender == 'M'">
                  <span class="genderBall" :class="{male : tabledata.gender == 'M'}"></span>
                </template>
              </template>
              <template v-else>
                <b-link  class="nameLink" @click="newtab(tabledata.member_no)" v-model="playernum">
                  {{ tabledata.playing_name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="oomTitleiest" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y' && home === false"
                    ><b-img
                      class="openImage"
                      src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/11/theopen.png"
                    ></b-img
                  ></span>
                  <template v-if="showGender == 'Y' && tourID !== 'wpg' && tabledata.gender == 'F'">
                    <!-- <span class="genderBall" :class="{male : tabledata.gender == 'M'}">•</span> -->
                    <span class="genderBall" :class="{female : tabledata.gender == 'F'}"></span>
                  </template>
                  <template v-else-if="showGender == 'Y' && tourID == 'wpg' && tabledata.gender == 'M'">
                    <span class="genderBall" :class="{male : tabledata.gender == 'M'}"></span>
                  </template>
                </b-link>
              </template>
              </td>
              <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ'" class="hideMob">
                <span v-if="data.show_winnings != 'B'" class="winningsPos">
                  {{ tabledata.winnings }}
                </span>
                <span v-else-if="tabledata.winnings !== '' && tabledata.winnings">
                  {{data.currency_sign}}
                  {{ tabledata.winnings }}
                </span>
              </td>
              <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && data.show_winnings == 'B' && data.have_points == 'Y'" >
                {{tabledata.points_both}}
              </td>
              <template v-if="match === 'N'">
                <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar < 0" class="up posDown">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar > 0" class="down posDown">
                  {{ tabledata.vspar }}
                </td>
                <td  class="posDown" v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.pos !== 'CUT'">
                  {{ tabledata.vspar }}
                </td>
                <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar < 0 && roundsPlayed > 1" class=" posDown">
                  {{ tabledata.score }}
                </td>
                <td
                  v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar > 0 && roundsPlayed > 1"
                  class=" posDown"
                >
                  {{ tabledata.score }}
                </td>
                <td class="posDown" v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && roundsPlayed > 1">
                  {{ tabledata.score }}
                </td>
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="hideMob"
                  v-show="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ'"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up posDown "
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down posDown"
                    >{{ tabledata.score }}</span
                  >
                  <span v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span v-else-if="tabledata['score_R' + i] < data.course_total_par.slice(1)" :class="up" class="posDown">{{
                    tabledata["score_R" + i]
                  }}</span>
                  <span
                    v-else-if="tabledata['score_R' + i] > data.course_total_par.slice(1)"
                    :class="down"
                    class="posDown"
                    >{{ tabledata["score_R" + i] }} </span
                  >
                  <span class="posDown" v-else>{{ tabledata["score_R" + i] }}</span>
                </td>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
                class="hideMob"
              >
                <a :href="'/playerprofile/' + tabledata.playerno">
                  <font-awesome-icon
                    style="color:#f2af15!important;"
                    id="user"
                    class="icon"
                    :icon="['fa', 'user']"
                  />
                </a>
              </td>
          </tr>
        </template>
        <tr class="middle-sec">
          <td colspan="11" style="text-align: center;">
            <template v-if="isMobile(true)">
              <div class="ad test"> 
                <div class="ad" style="text-align:center;">
                  <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" type="application/javascript"></script>
                  <script type="application/javascript">
                    window.googletag = window.googletag || {cmd: []};
                    googletag.cmd.push(function() {
                    billboardsizes = googletag.sizeMapping()
                    .addSize([0, 0], [320, 50])
                    .build();
                    googletag.defineSlot('/27436116/Golf_PGA_Leaderboard_Bottom', [[320,50]], 'leaderboardbottom').defineSizeMapping(billboardsizes).addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    });
                  </script>

                  <div id='leaderboardbottom' class="lazy" style="text-align:center; margin:auto">
                    <div>
                      <script type="application/javascript">
                        googletag.cmd.push(function() { googletag.display('leaderboardbottom'); });
                      </script>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- Desktop Add -->
              <div class="ad test">
                <div class="ad" style="text-align:center;">
                  <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" type="application/javascript"></script>
                  <script type="application/javascript">
                    window.googletag = window.googletag || {cmd: []};
                    googletag.cmd.push(function() {
                    billboardsizes = googletag.sizeMapping()
                    .addSize([980, 0], [[970, 90],[728, 90]])
                    .build();
                    googletag.defineSlot('/27436116/Golf_PGA_Leaderboard_Bottom', [[728,90],[970,90]], 'leaderboardbottom').defineSizeMapping(billboardsizes).addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    });
                  </script>

                  <div id='leaderboardbottom' class="lazy" style="text-align:center; margin:auto">
                    <div v-bind:style="{ 'background-image': 'url(' + 'https://tpc.googlesyndication.com/simgad/10857817674941707197' + ')' }" style="text-align:center; margin:auto; background-repeat: no-repeat; height: 90px; margin: auto; background-position: center;">
                      <script type="application/javascript">
                        googletag.cmd.push(function() { googletag.display('leaderboardbottom'); });
                      </script>
                    </div>
                  </div>
                </div>
              </div>
            </template> 
          </td>
        </tr>
        <template v-for="(tabledata, index) in Eds.slice(25,1000)">
          <tr @click.stop="rowClicked(index)" :key="index">
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.cut_round }}
              </td>
              <td class="cut" colspan="11" v-else-if="tabledata.pos === 'EOQ'">
                {{ tabledata.pos }}
              </td>
              <td
                class="posnum scorePos"
                v-else-if="index !== 0"
              >
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum scorePos" v-else-if="index === 0" >
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>


              <td v-else class="noPos"><span>.</span></td>

              <td class="mobHide" v-if="tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ' &&  home === false">
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <img
                    class="flag"
                    :src="
                      (config.VUE_APP_FLAG_URL + tabledata.nationality)
                        | lowercase
                    "
                  />
                  {{ tabledata.represents }}
                </span>
              </td>
              <td
                v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT' && tabledata.pos !== 'EOQ'"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                }"
              >
                <template v-if="tabledata.profile == 'N'">
                  {{ tabledata.playing_name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="oomTitleiest" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y' && home === false"
                    ><b-img
                      class="openImage"
                      src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/11/theopen.png"
                    ></b-img
                  ></span>
                  <template v-if="showGender == 'Y' && tourID !== 'wpg' && tabledata.gender == 'F'">
                    <!-- <span class="genderBall" :class="{male : tabledata.gender == 'M'}">•</span> -->
                    <span class="genderBall" :class="{female : tabledata.gender == 'F'}"></span>
                  </template>
                  <template v-else-if="showGender == 'Y' && tourID == 'wpg' && tabledata.gender == 'M'">
                    <span class="genderBall" :class="{male : tabledata.gender == 'M'}"></span>
                  </template>
                </template>
                <template v-else>
                  <b-link class="nameLink" @click="newtab(tabledata.member_no)" v-model="playernum">
                    {{ tabledata.playing_name }}
                    <span v-if="tabledata.pro_ind == 'Am'">(a)</span> 
                    <span v-if="tabledata.sponsored === 'Y'"
                      ><b-img class="oomTitleiest" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                    ></span>
                    <span v-if="tabledata.entry_sponsored === 'Y' && home === false"
                      ><b-img
                        class="openImage"
                        src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/11/theopen.png"
                      ></b-img
                    ></span>
                    <template v-if="showGender == 'Y' && tourID !== 'wpg' && tabledata.gender == 'F'">
                      <!-- <span class="genderBall" :class="{male : tabledata.gender == 'M'}">•</span> -->
                      <span class="genderBall" :class="{female : tabledata.gender == 'F'}"></span>
                    </template>
                    <template v-else-if="showGender == 'Y' && tourID == 'wpg' && tabledata.gender == 'M'">
                      <span class="genderBall" :class="{male : tabledata.gender == 'M'}"></span>
                    </template>
                  </b-link>
                </template>
              </td>
              <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ'" class="hideMob">
                <span v-if="data.show_winnings != 'B'"  class="winningsPos">
                  {{ tabledata.winnings }}
                </span>
                <span v-else-if="tabledata.winnings !== '' && tabledata.winnings">
                  {{data.currency_sign}}
                  {{ tabledata.winnings }}
                </span>
              </td>
              <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && data.show_winnings == 'B' && data.have_points == 'Y'" >
                {{tabledata.points_both}}
              </td>
              <template v-if="match === 'N'">
                <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar < 0" class="up posDown">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar > 0" class="down posDown">
                  {{ tabledata.vspar }}
                </td>
                <td class="posDown" v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.pos !== 'CUT'"
                  :class="{
                    smallsize: tabledata.vspar == 'RTD' || tabledata.vspar == 'WDN' || tabledata.vspar == 'DSQ'
                  }"                
                >
                  {{ tabledata.vspar }}
                </td>
                <td v-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar < 0 && roundsPlayed > 1" class=" posDown">
                  {{ tabledata.score }}
                </td>
                <td
                  v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && tabledata.vspar > 0 && roundsPlayed > 1"
                  class=" posDown"
                >
                  {{ tabledata.score }}
                </td>
                <td class="posDown" v-else-if="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ' && roundsPlayed > 1"
                    :class="{
                      smallsize: tabledata.vspar == 'RTD' || tabledata.vspar == 'WDN' || tabledata.vspar == 'DSQ'
                    }"
                >
                  {{ tabledata.score }}
                </td>
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="hideMob"
                  v-show="tabledata.pos != 'CUT' && tabledata.pos !== 'EOQ'"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up posDown "
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down posDown"
                    >{{ tabledata.score }}</span
                  >
                  <span v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span v-else-if="tabledata['score_R' + i] < data.course_total_par.slice(1)" :class="up" class="posDown">{{
                    tabledata["score_R" + i]
                  }}</span>
                  <span
                    v-else-if="tabledata['score_R' + i] > data.course_total_par.slice(1)"
                    :class="down"
                    class="posDown"
                    >{{ tabledata["score_R" + i] }} </span
                  >
                  <span class="posDown" v-else>{{ tabledata["score_R" + i] }}</span>
                </td>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    tabledata.pos !== 'EOQ' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
                class="hideMob"
              >
                <a :href="'/playerprofile/' + tabledata.playerno">
                  <font-awesome-icon
                    style="color:#f2af15!important;"
                    id="user"
                    class="icon"
                    :icon="['fa', 'user']"
                  />
                </a>
              </td>
          </tr>
        </template>
      </template>

      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import ads from '@/js/ads.js'

export default {
  name: "results",
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "match",
    "showGender"
  ],
  components: { 

  },
  data() {
    return {
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: [],
      win: "win",
      ads:ads,
      reportColour: process.env.VUE_APP_REPORT_MAIN_COLOUR,
      playernum:'',
      tourID: process.env.VUE_APP_URL_TOUR
    };
  },
  methods: {
    newtab: function (playernum) {   
        window.open("https://golf.com.au/Leaderboard#https://aus-reports.ocs-software.com/playerprofile/" + playernum, "_blank");    
    },
    isMobile() {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.tablePick === "Score" && this.clickedRow !== index)
        this.clickedRow = index;
      else this.clickedRow = -1;
    },
    playerCard: function(event) {
      var cardID = event.target.getAttribute("title");
      return (
        (this.cardID = cardID),
        axios
          .get(
            process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.code +
              "-cards-" +
              this.cardID +
              ".json?randomadd=" +
              new Date().getTime()
          )
          .then((response) => (this.playerCardData = response.data))
      );
    },
  },
  computed: {
    tablePick: function(picked) {
      if (this.title.includes("Tournament")) picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        this.title.includes("Scores") ||
        this.title.includes("Scoreboard")
      )
        picked = "Score";
      else if (this.title.includes("Live")) picked = "Live";
      else if (
        this.title.includes("Final") ||
        this.title.includes("Statistics")
      )
        picked = "Final";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    pftroundsPlayed() {
      return parseInt(this.data.pft_round);
    },
    Eds(reportData) {
      if (this.home === false) {
        if (this.title.includes("Tournament"))
          reportData = this.data.entries.entries_entry;
        else if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry;
        else if (
          (this.title.includes("Scores") && this.team === "N") ||
          (this.title.includes("Scoreboard") && this.team === "N") ||
          (this.title.includes("Live") && this.team === "N")
        )
          reportData = this.data.scores.scores_entry;
        else if (
          (this.title.includes("Scores") && this.team === "Y") ||
          (this.title.includes("Scoreboard") && this.team === "Y") ||
          (this.title.includes("Live") && this.team === "Y")
        )
          reportData = this.data.team_scores.team_scores_entry;
        else if (
          this.title.includes("Final") ||
          this.title.includes("Statistics")
        ) {
          reportData = this.data.result.result_entry;
          // var setOne = allData.slice(0, 5);
          // var setTwo = allData.slice(5, 25);
          // var setThree = allData.slice(25);
          // var addOne = this.ads[0];
          // var addTwo = "Test Two";
          // let comone = setOne.concat(addOne);
          // let comtwo = setTwo.concat(addTwo);
          // let comthree = comone.concat(comtwo);
          // reportData = comthree.concat(setThree);
        }
        return reportData;
      } else {
        if (this.title === "Tournament Entries")
          reportData = this.data.entries.entries_entry;
        else if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry;
        else if (
          this.title.includes("Scores") ||
          this.title.includes("Scoreboard")
        )
          reportData = this.data.scores.scores_entry;
        else if (
          this.title.includes("Final") ||
          this.title.includes("Statistics")
        )
          reportData = this.data.result.result_entry;
        return reportData;
      }
    },
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
    },
    immediate: true,
    deep: true,
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
  },
};
</script>

<style scoped>
th.theadSpace {
  /* width: 6%;  */
}
th.hideMob.theadSpaceValue {
  /* width: 8%; */
}
th.hideMob.theadSpace {
  /* width: 6%; */
}
.openImage {
  width: 20px;
  /* margin-left: 50px; */
  /* position: relative; */
  /* top: 5px; */
  /* float: right; */
  /* right: 14px; */
  margin-left: 10px;
}
::v-deep a.nameLink {
  color: #000 !important;
  /* position: relative;
  top: 8px; */
}
::v-deep span.winningsPos {
  /* position: relative;
  top: 8px; */
}
.playOFFred {
  color:red
}
td.smallsize {
  /* font-size: 0.7rem; */
  font-size: 14px;
}
span.smallsize {
  /* font-size: 0.7rem; */
  font-size: 14px;
}
td.nonScore {
  font-size: 0.7rem;
}
.bkImage {
  height: 90px;
  background-repeat: no-repeat;
  text-align: center;
  margin: auto;
  background-position: center;
}
img.oomTitleiest {
    width: 30px;
}
.bkred {
  background-color: red;
  color: white;
}
.female {
  color: #e33;
  background-color: #e33;
  height: 25px;
  width: 10px;
  float: left;
  margin-right: 4px;
}
.male {
  color: rgb(0, 60, 82);
  background-color: rgb(0, 60, 82);
  height: 25px;
  width: 10px;
  float: left;
  margin-right: 4px;
}
.genderBall {
  font-size: 30px !important;
  line-height: 0 !important;
  position: relative;
  top: 0px;
}
a.nameLink{
  color: #000 !important;
}
.catSection {
  padding-top: 16px!important;
}
.homeEntriesPos {
  margin-top: 8px!important;
}
.homeEntriesStatus {
  vertical-align: middle;
}
a.homeEntriesName {
  margin-top: 0px!important;
}
span.multiCourseSpanTeam {
  margin-top: 10px;
  float: right;
}
span.multiCourseSpan {
  float: right;
  margin-top: -17px;
}
span.multiCourseSpanTeam.B {
  color: #333333;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.Y {
  color: #d8db22;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.C {
  color: #1E90FF;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.R {
  color: #BB0000;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.G {
  color: #3c9933;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.O {
  color: #e07020;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpan.B {
  color: #333333;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.Y {
  color: #d8db22;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.C {
  color: #1E90FF;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.R {
  color: #BB0000;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.G {
  color: #3c9933;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.O {
  color: #e07020;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
.B {
  color: #333333;
}
.Y {
  color: #d8db22;
}
.C {
  color: #1E90FF;
}
.R {
  color: #BB0000;
}
.G {
  color: #3c9933;
}
.O {
  color: #e07020;
}
td.posDown {
  /* position: relative;
  padding-top: 20px; */
}
td.posDownWinnings {
  /* margin-top: 10px; */
  position: absolute;
}
span.posDown {
  /* position: relative;
  top: 8px; */
}
td.ParBlack{
  /* position: relative;
  padding-top: 20px; */
}
::v-deep span.ParBlack{
  /* position: relative;
  top: 3px; */
}
::v-deep span.down.posDown {
  /* position: relative;
  top: 3px; */
}
td.down.posDown {
  /* position: relative;
  padding-top: 20px; */
}
::v-deep span.up.posDown {
  /* position: relative;
  top: 3px; */
}
td.up.posDown {
  /* position: relative;
  padding-top: 20px; */
}
.scorePos {
  margin-left: 0px!important;
}
span.FlagScores {
  /* margin-top: 6px;
  display: block; */
}
::v-deep button#__BVID__32__BV_toggle_ {
  line-height: 35px;
  padding-bottom: 0;
  height: 40px;
}
td.drawName > a {
  margin-top: 1px;
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
  margin-top: 0px!important;
  padding-top: 7px!important;
  padding-bottom: 22px!important;
}
.title {
  text-align: center;
  background-color: #00433e;
  color: white;
}
.title > h3 {
  padding-top: 8px;
  margin-bottom: 0px;
  font-size: 24px;
}
.title > p {
  font-size: 16px !important;
  margin-bottom: 0;
}
::v-deep th:first-child {
    /* text-align: left!important;
    padding-left: 20px; */
}
th {
  position: sticky;
  top: 0;
  /* background-color: #00433e; */
  vertical-align: bottom;
  border-bottom: 0px solid #ddd;
  font-weight: bold;
  color: white;
  font-size: 13px;
  text-transform: capitalize;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  /* background: #00433e; */
  color: #ffffff !important;
  text-align: left;
  padding-bottom: 12px;
  padding-top: 12px;
  z-index: 2;
}

.win {
  background-color: #02b2dd !important;
  color: black;
}
.catD {
  background-color: #d4d4d4;
  color: #003C52;
  /* padding-top: 20px; */
}
.drawName {
  font-size: 14px !important;
}
table {
  width: 100%;
}

thead > tr {
  color: white;
}
td:first-child {
  text-align: center;
}
th:first-child {
  text-align: center;
}
th:nth-child(3) {
  text-align: left;
}
td:nth-child(3) {
  text-align: left;
}
.odd {
  background-color: white !important;
}
.even {
  background-color: #dfe1e6 !important;
}
tr:nth-child(even) {
  background-color: #fff;
}
td.posnum {
  /* padding: 5px;
  padding-top: 4px;
  padding-bottom: 4px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0;
  color: #000; */
  /* position: relative;
  top: 3px; */
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
}
::v-deep td > a {
  /* margin-top: 6px; */
  display: block;
}
td {
  /* padding: 12px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 0px solid #ddd;
  border-right: none !important;
  cursor: pointer;
  text-align: left;
  padding-left: 0px; */
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  height: 53px;
  color: #000000;
}

td.posnum > span {
  /* padding: 5px;
  display: block;
  max-width: 58px;
  position: relative;
  top: 8px; */
}
.noPos > span {
  color: transparent;
  /* padding: 5px;
  display: block;
  max-width: 58px; */
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
::v-deep .up {
  color: #a52a2a;
}
::v-deep .down {
  color: #1e90ff;
}
.text-down {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: glow-red 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 10px rgba(255, 82, 82, 0.7);
  }
}

.text-up {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: glow-green 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-green {
  to {
    text-shadow: 0 0 10px rgba(51, 217, 178, 0.7);
  }
}
.cut {
  padding-top: 6px !important;
  padding-right: 6px !important;
  padding-bottom: 6px !important;
  font-size: 19px;
  vertical-align: middle;
  padding-left: 8px !important;
  background: #aa0003;
  color: white;
}
::v-deep a:hover{
      color: #00b588!important;
      text-decoration: none;
}
@media only screen and (max-width: 768px) {
  .openImage {
    width: 15px;
    /* margin-left: 50px; */
    position: relative;
    top: 0px;
    float: right;
    right: 14px;
  }
  .hideMob {
    display: none;
  }
  td {
    font-size: 12px !important;
  }
  th {
    font-size: 13px;
  }
  .mobHide {
    display: none;
  }
  #reportCard {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .oomTitleiest {
    width: 30px;
  }
  td.up.posDown {
    position: relative;
    /* padding-top: 12px; */
  }
  td.posDown {
    position: relative;
    /* padding-top: 12px; */
  }
  td.down.posDown {
    position: relative;
    /* padding-top: 12px; */
  }
  .genderBall {
    font-size: 20px !important;
    line-height: 0 !important;
    position: relative;
    top: 0px;
    left: 0px;
  }
}
@media only screen and (max-width: 500px) {
  .openImage {
    width: 15px;
    /* margin-left: 50px; */
    position: relative;
    top: 0px;
    float: right;
    right: -4px;
  }
  .genderBall {
    font-size: 20px !important;
    line-height: 0 !important;
    position: relative;
    top: 0px;
    left: 0px;
  }
}
</style>